import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, Pill, Empty } from "@/dashboard/ui";
import { ClipboardList, Check } from "lucide-react";

export default function TasksPanel() {
  const [tasks, setTasks] = useState(null);

  const load = () => api.get("/tasks").then((r) => setTasks(r.data)).catch(() => setTasks([]));
  useEffect(() => {
    load();
  }, []);

  const toggle = async (t) => {
    await api.post(`/tasks/${t.id}/toggle`);
    load();
  };

  if (tasks === null) return <p className="py-8 text-center text-sm text-neutral-400">Loading…</p>;
  if (tasks.length === 0) {
    return (
      <Empty
        testid="tasks-empty"
        icon={ClipboardList}
        title="No follow-up tasks yet"
        body="Add a lead with a follow-up date and a task is created here automatically."
      />
    );
  }

  const today = new Date().toISOString().slice(0, 10);

  return (
    <div className="space-y-2.5" data-testid="tasks-list">
      {tasks.map((t) => {
        const overdue = t.status === "open" && t.due_date && t.due_date <= today;
        return (
          <Card key={t.id} className="flex items-center justify-between gap-4 p-4" data-testid={`task-${t.id}`}>
            <div className="flex items-center gap-3.5">
              <button
                data-testid={`task-toggle-${t.id}`}
                onClick={() => toggle(t)}
                aria-label={t.status === "open" ? "Mark done" : "Reopen"}
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border transition-colors ${
                  t.status === "done" ? "border-[#111111] bg-[#111111] text-white" : "border-neutral-300 hover:border-[#111111]"
                }`}
              >
                {t.status === "done" && <Check size={13} strokeWidth={3} />}
              </button>
              <div>
                <p className={`text-sm font-semibold ${t.status === "done" ? "text-neutral-400 line-through" : "text-[#111111]"}`}>
                  {t.title}
                </p>
                <p className="text-xs text-neutral-400">{t.lead_name}</p>
              </div>
            </div>
            {t.due_date && (
              <Pill tone={t.status === "done" ? "grey" : overdue ? "red" : "outline"}>
                {t.status === "done" ? "Done" : overdue ? `Overdue · ${t.due_date}` : `Due ${t.due_date}`}
              </Pill>
            )}
          </Card>
        );
      })}
    </div>
  );
}
